import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      fill="none"
      viewBox="0 0 15 16"
    >
      <path
        stroke="#F71"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M8 8.667a.667.667 0 100-1.333.667.667 0 000 1.333zM12.667 8.667a.667.667 0 100-1.333.667.667 0 000 1.333zM3.333 8.667a.667.667 0 100-1.333.667.667 0 000 1.333z"
      />
    </svg>
  )
}

export default Icon
